module.exports = __webpack_public_path__ + "img/mako-satin_icon.992062c6.png";